/*
Usage Notes: 

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  {% assign skioSellingPlanGroups = product.selling_plan_groups | where: 'app_id', 'SKIO' %}
  {% if skioSellingPlanGroups.size > 0 %}
    <skio-plan-picker 
      product='{{ product | json | escape }}'
      selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
      formId='{{ product_form_id }}'
      currency='{{ cart.currency.iso_code }}'
      >
    </skio-plan-picker>
    <input type="hidden" aria-hidden="true" name="selling_plan" value="">
    <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>
  {% endif %}

  Note: formId not required if element is inside of a form already

  Example variantChanged event dispatch:
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
*/

import {
  LitElement,
  html,
  css,
} from "https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js";

const skioStyles = css`
  .product__info-container skio-plan-picker {
    margin-top: 0;
  }
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0;
    border: 0;
    font-family: "Inter" !important;
    margin-bottom: 20px;
  }
  .skio-onetime-second {
    order: 2;
  }
  .skio-group-container {
    display: none;
    margin-bottom: 10px;
  }
  .skio-group-container--available {
    display: block;
    border-radius: 6px;
    border: 2px solid transparent;
    transition: border-color 0.2s ease;
  }
  .skio-group-container--available.skio-otp {
    border: 1px solid #d9d9d9;
  }
  .skio-group-container--selected {
    border: 2px solid black !important;
  }
  .skio-group-container--selected.skio-otp {
    border-width: 2px !important;
  }

  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 6px;
  }

  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 10px;
    overflow: hidden;
  }

  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    font-size: 16px;
    line-height: 1;
  }

  .skio-radio__container {
    display: flex;
    margin-right: 10px;
    color: black;
  }
  .skio-radio-icon {
    background: white;
    border-radius: 100%;
  }

  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }

  .skio-price {
    margin-left: auto;
    letter-spacing: 0.4px;
    color: black;
    font-weight: 700;
    display: flex;
  }
  .skio-price > del {
    margin-right: 10px;
    display: block;
    max-width: fit-content;
  }
  .skio-group-content {
    width: auto;
    margin-left: 30px;
    transition: max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    opacity: 1;
  }

  .skio-group-title {
    min-width: max-content;
    font-weight: 700;
    letter-spacing: 0.4px;
    color: black;
  }

  .skio-save {
    color: white;
    background: #24c263;
    padding-top: 11px;
    min-width: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-bottom: 11px;
    font-weight: 700;
    display: flex;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    line-height: 1;
    cursor: pointer;
  }
  .skio-frequency-container {
    display: flex;
    gap: 16px;
    font-weight: 700;
    font-size: 16px;
    color: black;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    font-family: "Inter";
  }
  .skio-frequency {
    max-width: fit-content;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 6.5px 46px 6.5px 16px;
    border-radius: 6px;
    background-color: white;
    width: 100%;
    border: black solid 1px;
    font-size: 16px;
    font-family: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    -webkit-appearance: none; /* Remove iOS-specific styles */
    appearance: none;
    color: inherit; /* Ensure consistent text color */
    border-color: inherit; /* Ensure consistent border color */
    -moz-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
    pointer-events: none;
  }

  .skio-frequency span {
    text-transform: lowercase;
  }

  button.add-to-cart {
    justify-content: center;
    font-weight: 400;
    text-transform: capitalize;
    letter-spacing: 0;
    font-style: normal;
    font-size: 16px;
    text-decoration: none;
    box-shadow: 0 0 #0000004d inset;
    width: 100%;
    color: #fff;
    background-color: #000;
    border-radius: 5px;
    transition-duration: 0.3s;
    padding: 10px 32px;
    text-transform: uppercase;
    cursor: pointer;
    font-family: "FK Grotesk Neue Trial";
    transition: border-color 0.25s ease, background-color 0.25s ease,
      color 0.25s ease;

    border: solid 2px rgba(0, 0, 0, 0);
  }
  button.add-to-cart:hover {
    background-color: rgba(0, 0, 0, 0);
    color: #000;
    border-color: #000;
  }

  .skio-details {
    --text-color: #333;
    --text-color-secondary: #888;
    margin-left: 30px;
    order: 3;
  }

  .skio-details summary::-webkit-details-marker,
  .skio-details summary::marker,
  .skio-details slot {
    color: rgba(0, 0, 0, 0) !important;
  }

  .skio-details summary {
    margin-top: 15px;
  }
  .skio-details summary:hover {
    text-decoration: underline;
  }
  .skio-details summary span {
    font-size: 16px;
    font-weight: 700;
    display: flex;
    padding: 0.5em 0;
    cursor: pointer;
    align-items: center;
    gap: 10px;
    margin-top: -40px;
    color: #000;
  }

  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translateY(-15px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  .skio-details--content {
    position: fixed;
    z-index: 1020;
    padding-top: 24px;
    padding-bottom: 45px;
    padding-left: 45px;
    padding-right: 45px;
    width: fit-content;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
    cursor: default;
    pointer-events: auto !important;
    max-width: 572px;
    max-height: 65vh;
    overflow-y: scroll;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: all 1s ease-out;
  }
  .skio-details ul {
    margin: 0;
    padding: 0;
  }

  .skio-details ul li {
    display: flex;
    align-items: flex-start;
    gap: 29px;

    margin-bottom: 1em;
  }

  .skio-details .skio-content {
    display: flex;
    flex-direction: column;
  }

  .skio-details .skio-content p {
    font-size: 18px;
    line-height: 1;
    margin-top: 0;
    margin-bottom: 10px;

    letter-spacing: 0;

    color: black;
  }

  .skio-details ul li small {
    color: black;
    line-height: 1.4;
    font-size: 16px;
  }

  .skio-details .skio-icon {
    width: 64px;
    height: 64px;
  }

  .skio-details .skio-icon svg {
    width: 64px;
    height: 64px;
  }

  .skio-details--footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9em;
  }

  .skio-details--footer a {
    color: var(--text-color);
  }

  .skio-manage-link {
    width: 100%;
    text-decoration: underline;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
  }

  .powered-by-skio {
    font-size: 0.8em;

    display: flex;
    text-decoration: none;

    align-items: center;
    gap: 3px;
  }
  .skio-subscribe {
    background: #f3f3f3;
    padding-top: 14px !important;
    padding-bottom: 19px !important;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .skio-list-items {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    gap: 10px;
    margin-left: 30px;
    margin-top: 10px;
    color: black;
  }
  .skio-list-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
  }
  .skio-modal-list-item {
    background: #f5f5f5;
    border-radius: 6px;
    padding: 23px 30px;
  }
  .skio-content-subscribe {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 10px;
  }
  .skio-content-subscribe .skio-content > ul {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 10px;
  }
  .skio-content-subscribe .skio-content > ul > li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-wrap: nowrap;
    gap: 18px;
    color: black;
    margin-bottom: 0;
  }
  .skio-details-close {
    display: block;
    margin-left: auto;
    height: 33px;
    width: 33px;
    cursor: pointer;
    margin-bottom: 18px;
  }
  .skio-details--content-header {
    font-size: 27px;
    line-height: 1;
    font-weight: 700;
    text-align: center;
    margin-bottom: 26px;
    color: black;
  }
  .skio-details-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    pointer-events: none;
    z-index: 1000;
    cursor: pointer;
    background: black;
    transition: all 0.3s ease-in-out;
  }
  @media screen and (min-width: 768px) and (max-width: 1280px) {
    .skio-details--content {
      top: 45%;
      max-height: 50vh;
    }
  }
  @media screen and (max-width: 768px) {
    .skio-details .skio-icon {
      width: 40px;
      height: 40px;
    }

    .skio-details .skio-icon svg {
      width: 40px;
      height: 40px;
    }
    .skio-frequency-container {
      gap: 8px;
      font-size: 14px;
      letter-spacing: -0.15px;
    }
    .skio-frequency {
      padding-right: 26px;
    }
    .skio-list-items {
      margin-top: 16px;
      margin-bottom: 10px;
      gap: 6px;
    }
    .skio-list-item {
      font-size: 14px;
      text-wrap: nowrap;
      letter-spacing: -0.25px;
      gap: 8px;
    }
    .skio-price {
      display: flex;
      flex-direction: column;
    }
    .skio-price > skio-subscription-price {
      order: 1;
    }
    .skio-price > del {
      display: none;
    }
    .skio-details summary span {
      justify-content: flex-start;
      letter-spacing: -0.15px;
      text-decoration: underline;
    }
    .skio-details--content {
      overflow-y: scroll;
      width: fit-content;
      padding: 20px !important;
      max-width: 100%;
      min-width: 80%;
    }
    .skio-details ul li {
      gap: 15px;
    }
    .skio-details .skio-content p {
      font-size: 16px;
    }
    .skio-details ul li small {
      font-size: 12px;
    }
    .skio-content-subscribe .skio-content > ul {
      gap: 0;
    }
    .skio-content-subscribe .skio-content > ul > li {
      font-size: 12px !important;
      text-align: left !important;
      text-wrap: wrap !important;
    }
    .skio-content-subscribe .skio-content > ul > li > svg {
      min-width: 15px;
      max-width: 15px;
    }
    .skio-modal-list-item {
      background: #f5f5f5;
      border-radius: 6px;
      padding: 20px 15px;
      flex-direction: column;
      justify-content: center !important;
      align-items: center !important;
      text-align: center !important;
      margin-bottom: 8px;
    }
    .skio-manage-link {
      font-size: 16px;
    }
    .skio-details-close {
      height: 24px;
      width: 24px;
    }
    .skio-details--content-header {
      font-size: 20px;
      margin-bottom: 10px;
    }
  }
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object }, //required
    productHandle: { type: String }, //optional (unless product isn't passed, then required)
    key: { type: String }, //optional, defaults to product.id; identifier for this instance of the Skio plan picker

    formId: { type: String }, //optional; if passed, used to connect input fields to form
    needsFormId: { type: Boolean }, //optional, defaults to false; if true, element needs to be passed a formId, else it searches for a form

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    discountFormat: { type: String }, //optional, defaults to percent; can also pass "fixed"

    currency: { type: String }, //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String }, //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {}, //placeholder for object

    externalPriceSelector: { type: String }, //optional, used to update the external price

    externalPriceSelectorWithCurrency: { type: String }, //optional, used to update the external price

    selectedVariant: { type: Object }, //placeholder for data
    skioSellingPlanGroups: {}, //placeholder for data
    availableSellingPlanGroups: {}, //placeholder for data
    selectedSellingPlanGroup: {}, //placeholder for data
    selectedSellingPlan: {}, //placeholder for data

    defaultFrequency: {}, //placeholder for data

    showAddToCartButton: { type: Boolean },

    meta: {},

    useVariantInputClickEvents: { type: Boolean }, // optional, allows use of variant input click events to update skio's selectedVariant
    variantInputSelector: {},
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.purchaseOption = "onetime";

    this.key = null;
    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = this.getAttribute('preselectSubscription') === 'true';
    this.subscriptionFirst = false;

    this.skioMainProduct = true;

    this.discountFormat = "percent";

    this.externalPriceSelector = "[skio-external-price]";

    this.externalPriceSelectorWithCurrency =
      "[skio-external-price-with-currency]";

    this.currency = Shopify.currency.active;
    this.language = "en-US";
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: "currency",
      currency: this.currency,
    });

    this.defaultFrequency = null;
    this.container = document.querySelector('body')
    this.showAddToCartButton = false;

    this.meta = "";

    this.lastSellingPlanName = "";

    this.showDetailsHover = false;

    this.useVariantInputClickEvents = null;
    this.variantInputSelector = null;
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.startSubscription == true) {
      this.purchaseOption = "subscription";
    }

    if (!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    if (this.needsFormId && this.formId == null) {
      let forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length > 0) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute("skio-key")) {
            if (el.getAttribute("skio-key") == this.key) form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }
    let skio = this;
    document.addEventListener("variantChanged", function (e) {
      //update variant id
      let variantId = e.detail.variantId;
      let variant = skio.product.variants.find((x) => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: "currency",
      currency: skio.currency,
    });

    if (this.meta !== "") this.meta = JSON.parse(this.meta);

    if (this.useVariantInputClickEvents) {
      document.addEventListener("load", skio.addVariantClickEventListeners);
    }
  }

  render() {
    if (
      !this.product ||
      !this.selectedVariant ||
      this.skioSellingPlanGroups.length == 0 ||
      !this.product?.available
    )
      return;

    return html` <fieldset
      class="skio-plan-picker"
      skio-plan-picker="${this.key}"
    >
      <input
        ${this.formId !== null ? html`form="${this.formId}"` : ""}
        name="selling_plan"
        type="hidden"
        value="${this.selectedSellingPlan !== null
          ? this.selectedSellingPlan?.id
          : ""}"
      />
      <input
        ${this.formId !== null ? html`form="${this.formId}"` : ""}
        name="properties[Discount]"
        type="hidden"
        value="${this.selectedSellingPlan !== null
          ? this.discount(this.selectedSellingPlan).percent
          : ""}"
        ?disabled="${this.selectedSellingPlan == null ? true : false}"
      />

      <div
        class="skio-group-container skio-otp ${this.product
          .requires_selling_plan == false
          ? "skio-group-container--available"
          : ""} ${this.selectedSellingPlanGroup == null
          ? "skio-group-container--selected"
          : ""} ${this.subscriptionFirst ? "skio-onetime-second" : ""}"
        skio-group-container
        @click=${() => this.selectSellingPlanGroup(null)}
      >
        <input
          id="skio-one-time-${this.key}"
          class="skio-group-input"
          name="skio-group-${this.key}"
          type="radio"
          value=""
          skio-one-time
          ?checked=${this.startSubscription == false &&
          this.product.requires_selling_plan == false
            ? true
            : false}
        />
        <label class="skio-group-label" for="skio-one-time-${this.key}">
          <div class="skio-group-topline">
            <div class="skio-radio__container">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="2"
                ></circle>
                <circle
                  class="skio-radio"
                  cx="12"
                  cy="12"
                  r="7"
                  fill="currentColor"
                ></circle>
              </svg>
            </div>
            <div class="skio-group-title">ONE-TIME ORDER</div>
            <div class="skio-price">
              <span skio-onetime-price
                >${this.moneyFormatter.format(
                  this.selectedVariant.price / 100
                )}</span
              >
            </div>
          </div>
        </label>
      </div>
      ${this.availableSellingPlanGroups
        ? this.availableSellingPlanGroups.map(
            (group, index) =>
              html`
                <div
                  class="skio-group-container skio-group-container--available ${this
                    .selectedSellingPlanGroup == group
                    ? "skio-group-container--selected"
                    : ""}"
                  skio-group-container
                  @click=${() => this.selectSellingPlanGroup(group)}
                >
                  <span class="skio-save"
                    >BEST VALUE - SAVE &nbsp;
                    <span skio-discount
                      >${this.discountFormat == "percent"
                        ? this.discount(group.selected_selling_plan).percent
                        : this.discount(group.selected_selling_plan)
                            .amount}</span
                    ></span
                  >
                  <input
                    id="skio-selling-plan-group-${index}-${this.key}"
                    class="skio-group-input"
                    name="skio-group-${this.key}"
                    type="radio"
                    value="${group.id}"
                    skio-selling-plan-group="${group.id}"
                    ?checked=${this.selectedSellingPlanGroup == group
                      ? true
                      : false}
                  />
                  <label
                    class="skio-group-label skio-subscribe"
                    for="skio-selling-plan-group-${index}-${this.key}"
                  >
                    <div class="skio-group-topline">
                      <div class="skio-radio__container">
                        <svg
                          class="skio-radio-icon"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="2"
                          ></circle>
                          <circle
                            class="skio-radio"
                            cx="12"
                            cy="12"
                            r="7"
                            fill="currentColor"
                          ></circle>
                        </svg>
                      </div>
                      <div class="skio-group-title">
                        ${group.name == "Subscription"
                          ? "SUBSCRIBE & SAVE"
                          : group.name}
                        ${this.discount(group.selected_selling_plan).percent !==
                        "0%"
                          ? html``
                          : html``}
                      </div>
                      <div class="skio-price">
                        <del
                          >${this.moneyFormatter.format(
                            this.selectedVariant.price / 100
                          )}
                        </del>

                        <span skio-subscription-price
                          >${this.price(group.selected_selling_plan)}</span
                        >
                      </div>
                    </div>
                    <div class="skio-list-items">
                      <div class="skio-list-item">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_404_1881)">
                            <circle cx="11" cy="11" r="11" fill="#08990F" />
                            <path
                              d="M6.11114 11L8.2292 13.1181C8.9533 13.8422 9.31535 14.2042 9.75592 14.1842C10.1965 14.1643 10.5243 13.7709 11.1799 12.9842L15.8889 7.33334"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_404_1881">
                              <rect width="22" height="22" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        Change, pause or cancel anytime
                      </div>
                      <div class="skio-list-item">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_404_1881)">
                            <circle cx="11" cy="11" r="11" fill="#08990F" />
                            <path
                              d="M6.11114 11L8.2292 13.1181C8.9533 13.8422 9.31535 14.2042 9.75592 14.1842C10.1965 14.1643 10.5243 13.7709 11.1799 12.9842L15.8889 7.33334"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_404_1881">
                              <rect width="22" height="22" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        Exclusive giveaways + gifts
                      </div>
                      <div class="skio-list-item">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_404_1881)">
                            <circle cx="11" cy="11" r="11" fill="#08990F" />
                            <path
                              d="M6.11114 11L8.2292 13.1181C8.9533 13.8422 9.31535 14.2042 9.75592 14.1842C10.1965 14.1643 10.5243 13.7709 11.1799 12.9842L15.8889 7.33334"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_404_1881">
                              <rect width="22" height="22" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        10% off on every order
                      </div>
                    </div>
                    <div class="skio-group-content">
                      <div class="skio-frequency-container">
                        Delivery:
                        <select
                          skio-selling-plans="${group.id}"
                          class="skio-frequency${group.selling_plans.length == 1
                            ? " skio-frequency--one"
                            : ""}"
                          @change=${(e) =>
                            this.selectSellingPlan(e.target, group)}
                        >
                          ${group
                            ? group.selling_plans.map(
                                (selling_plan) =>
                                  html`
                                    <option
                                      value="${selling_plan.id}"
                                      ?selected=${group.selected_selling_plan ==
                                      selling_plan}
                                    >
                                      ${group.name == "Subscription"
                                        ? ` ${selling_plan.name.toLowerCase()}`
                                        : `${selling_plan.name}`}
                                    </option>
                                  `
                              )
                            : ""}
                        </select>
                      </div>
                    </div>
                    <details
                      class="skio-details"
                      @click=${(e) => this.detailsMouseover()}
                    >
                      <summary>
                        <span>
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_469_78)">
                              <path
                                d="M11.611 5.49971C11.611 5.83721 11.3374 6.11082 10.9999 6.11082C10.6624 6.11082 10.3888 5.83721 10.3888 5.49971C10.3888 5.1622 10.6624 4.8886 10.9999 4.8886C11.3374 4.8886 11.611 5.1622 11.611 5.49971Z"
                                stroke="#33363F"
                              />
                              <path
                                d="M11 17.1108V8.55527"
                                stroke="#33363F"
                                stroke-width="2"
                              />
                              <circle
                                cx="11"
                                cy="11"
                                r="10.5"
                                stroke="#33363F"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_469_78">
                                <rect width="22" height="22" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>

                          Subscription details
                        </span>
                      </summary>
                      <div class="skio-details--content">
                        <svg
                          class="skio-details-close"
                          @click=${(e) => this.detailsMouseleave()}
                          width="37"
                          height="37"
                          viewBox="0 0 37 37"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M35.1136 1.8866L1.88635 35.1139"
                            stroke="#222222"
                            stroke-width="1.95455"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M1.8865 1.88647L35.1138 35.1137"
                            stroke="#222222"
                            stroke-width="1.95455"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div class="skio-details--content-header">
                        SUBSCRIBE & SAVE
                        </div>
                        <ul>
                          <li class="skio-modal-list-item">
                            <div class="skio-icon">
                              <svg
                                version="1.0"
                                xmlns="http://www.w3.org/2000/svg"
                                width="64.000000pt"
                                height="64.000000pt"
                                viewBox="0 0 64.000000 64.000000"
                                preserveAspectRatio="xMidYMid meet"
                              >
                                <g
                                  transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
                                  fill="#000000"
                                  stroke="none"
                                >
                                  <path
                                    d="M141 626 c-7 -8 -11 -27 -9 -43 l3 -28 185 0 c171 0 185 1 188 18 2
                              10 1 29 -2 43 l-6 24 -174 0 c-139 0 -176 -3 -185 -14z"
                                  />
                                  <path
                                    d="M136 510 c-38 -24 -46 -38 -46 -82 l0 -38 230 0 230 0 0 35 c0 23 -7
                              41 -20 53 -11 9 -29 25 -40 35 -17 15 -41 17 -172 16 -131 0 -157 -3 -182 -19z"
                                  />
                                  <path
                                    d="M90 250 l0 -130 230 0 230 0 0 130 0 130 -230 0 -230 0 0 -130z m247
                              51 c-5 -26 -3 -30 18 -33 25 -3 24 -4 -16 -50 -46 -54 -67 -63 -44 -18 16 31
                              16 31 -23 42 -8 2 0 18 23 46 20 23 39 42 42 42 3 0 3 -13 0 -29z"
                                  />
                                  <path
                                    d="M90 65 c0 -34 5 -47 19 -55 26 -13 396 -13 422 0 14 8 19 21 19 55
                              l0 45 -230 0 -230 0 0 -45z"
                                  />
                                </g>
                              </svg>
                            </div>
                            <div class="skio-content">
                              <p><strong>Stay Stocked!</strong></p>
                              <small>
                                Never have to think about reordering, stay
                                stocked with your favourite EHP products!</small
                              >
                            </div>
                          </li>
                          <li class="skio-modal-list-item">
                            <div class="skio-icon">
                              <svg
                                version="1.0"
                                xmlns="http://www.w3.org/2000/svg"
                                width="192.000000pt"
                                height="195.000000pt"
                                viewBox="0 0 192.000000 195.000000"
                                preserveAspectRatio="xMidYMid meet"
                              >
                                <g
                                  transform="translate(0.000000,195.000000) scale(0.100000,-0.100000)"
                                  fill="#000000"
                                  stroke="none"
                                >
                                  <path
                                    d="M23 1920 c-23 -28 -23 -31 -23 -363 0 -327 0 -334 21 -353 20 -18 43
                              -19 363 -22 l343 -3 50 48 c106 100 251 97 353 -7 l39 -40 333 0 c275 0 337 3
                              358 15 14 8 33 18 43 21 16 6 17 31 17 344 l0 337 -25 11 c-14 6 -25 18 -25
                              27 0 13 -102 15 -912 14 l-913 0 -22 -29z m642 -183 c35 -20 40 -27 40 -57 0
                              -30 -4 -36 -25 -39 -14 -1 -39 5 -57 14 -17 10 -39 15 -48 11 -28 -11 -12 -40
                              30 -54 93 -31 138 -100 109 -171 -23 -56 -56 -75 -130 -74 -90 1 -144 36 -144
                              94 0 35 65 45 91 13 12 -15 84 -19 93 -6 9 15 -24 52 -45 52 -34 0 -97 43
                              -113 78 -20 41 -20 55 -1 91 35 68 126 90 200 48z m222 -7 c9 -16 13 -63 12
                              -133 -1 -120 5 -137 55 -137 51 0 56 12 56 141 0 98 3 120 18 139 14 18 25 21
                              45 16 34 -8 40 -41 36 -188 -4 -120 -12 -141 -67 -182 -35 -27 -128 -27 -172
                              1 -61 38 -70 65 -70 209 0 106 3 131 17 146 22 25 54 19 70 -12z m509 -3 c34
                              -31 37 -37 36 -92 0 -36 5 -67 14 -79 8 -11 14 -43 14 -71 0 -45 -4 -55 -34
                              -84 -30 -29 -41 -33 -107 -38 -43 -3 -86 0 -101 6 l-28 11 0 174 c0 209 -2
                              206 101 206 65 0 72 -2 105 -33z"
                                  />
                                  <path
                                    d="M1283 1654 c-3 -8 1 -22 9 -30 12 -12 17 -12 33 -1 23 17 14 47 -15
                              47 -11 0 -23 -7 -27 -16z"
                                  />
                                  <path
                                    d="M1280 1490 c0 -30 1 -31 43 -28 37 3 42 6 42 28 0 22 -5 25 -42 28
                              -42 3 -43 2 -43 -28z"
                                  />
                                  <path
                                    d="M890 1173 c-62 -43 -59 -25 -60 -415 0 -208 -4 -367 -10 -382 -14
                              -39 -51 -52 -84 -31 l-26 17 0 144 c0 162 -5 171 -55 101 -80 -112 -101 -201
                              -71 -297 25 -79 48 -113 144 -212 l95 -98 418 0 418 0 43 43 c24 24 61 79 83
                              123 l40 79 0 236 c0 233 0 238 -23 262 -34 37 -91 52 -136 37 -20 -6 -44 -23
                              -52 -36 -19 -28 -34 -23 -34 12 0 14 -15 41 -36 64 -34 37 -40 40 -89 40 -48
                              0 -56 -4 -92 -39 l-39 -39 -32 39 c-31 37 -36 39 -90 39 -50 -1 -61 -4 -86
                              -30 -16 -16 -33 -27 -37 -24 -5 3 -9 74 -9 157 -1 129 -3 155 -18 172 -30 36
                              -65 55 -102 55 -20 0 -47 -8 -60 -17z"
                                  />
                                </g>
                              </svg>
                            </div>
                            <div class="skio-content">
                              <p><strong>Subscribe, your way! </strong></p>
                              <small
                                >Products are automatically delivered on your
                                schedule. No commitment, modify or cancel your
                                subscription anytime, no questions asked!
                              </small>
                            </div>
                          </li>
                          <li class="skio-modal-list-item">
                            <div class="skio-icon">
                              <svg
                                version="1.0"
                                xmlns="http://www.w3.org/2000/svg"
                                width="192.000000pt"
                                height="192.000000pt"
                                viewBox="0 0 192.000000 192.000000"
                                preserveAspectRatio="xMidYMid meet"
                              >
                                <g
                                  transform="translate(0.000000,192.000000) scale(0.100000,-0.100000)"
                                  fill="#000000"
                                  stroke="none"
                                >
                                  <path
                                    d="M928 1847 c-40 -19 -68 -38 -68 -47 0 -18 70 -90 88 -90 11 0 83 67
                              111 103 12 15 11 21 -9 42 -30 32 -40 31 -122 -8z"
                                  />
                                  <path
                                    d="M1194 1763 c-24 -4 -154 -127 -154 -144 0 -6 20 -33 44 -61 80 -92
                              84 -211 11 -303 -18 -22 -45 -47 -61 -55 -43 -21 -74 -51 -89 -86 -14 -34 -93
                              -104 -118 -104 -9 0 -26 -20 -38 -45 -27 -54 -61 -88 -120 -119 -24 -13 -46
                              -32 -48 -42 -12 -64 -139 -154 -216 -154 -49 0 -138 42 -181 85 -19 19 -37 35
                              -39 35 -2 0 -45 -41 -95 -91 -134 -137 -145 -109 158 -411 200 -200 253 -248
                              274 -248 21 0 63 36 206 179 l178 180 95 4 c157 6 183 23 465 309 180 182 202
                              208 208 244 12 69 -2 114 -50 161 -37 36 -43 46 -38 71 10 48 -13 108 -53 141
                              -34 28 -36 33 -38 98 -3 66 -4 69 -46 106 -41 36 -42 40 -44 103 -3 59 -6 69
                              -36 100 -44 46 -103 61 -175 47z"
                                  />
                                  <path
                                    d="M597 1725 c-33 -32 -37 -41 -37 -88 0 -29 5 -58 11 -64 8 -8 -1 -13
                              -37 -19 -56 -8 -79 -21 -105 -61 -25 -38 -23 -70 6 -118 30 -49 31 -58 4 -50
                              -23 8 -76 -11 -100 -35 -31 -31 -42 -84 -26 -123 8 -19 20 -38 26 -41 21 -14
                              11 -26 -22 -26 -66 0 -116 -54 -117 -127 0 -52 1 -53 75 -128 75 -75 75 -75
                              129 -75 51 0 57 3 86 38 37 44 46 75 32 107 -10 22 -9 23 49 27 83 6 111 34
                              117 118 4 52 7 60 21 54 31 -14 75 -4 110 24 33 26 36 34 39 86 l3 56 53 0
                              c49 0 57 3 85 35 72 83 61 108 -123 293 -152 151 -154 152 -198 152 -38 0 -51
                              -6 -81 -35z"
                                  />
                                  <path
                                    d="M1530 594 c-225 -225 -316 -297 -390 -306 -52 -6 -35 -36 86 -154
                              100 -98 121 -115 146 -112 38 4 548 511 548 545 0 13 -6 23 -13 23 -7 0 -53
                              41 -102 90 -49 50 -92 90 -95 90 -3 0 -84 -79 -180 -176z"
                                  />
                                </g>
                              </svg>
                            </div>

                            <div class="skio-content">
                              <p><strong>We’ll look after you!</strong></p>
                              <small>
                                If you’re not 100% satisfied, let us know and
                                we’ll make it right!</small
                              >
                            </div>
                          </li>
                          <li
                            class="skio-modal-list-item skio-content-subscribe"
                          >
                            <div class="skio-content ">
                              <p><strong>HOW TO SUBSCRIBE</strong></p>
                              <small>
                                It's easy, get started in just 3 simple
                                steps.</small
                              >
                              <ul>
                                <li>
                                  <svg
                                    width="22"
                                    height="23"
                                    viewBox="0 0 22 23"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="11"
                                      cy="11.5"
                                      r="11"
                                      fill="black"
                                    />
                                    <path
                                      d="M6.11114 11.5L8.2292 13.6181C8.9533 14.3422 9.31535 14.7042 9.75592 14.6842C10.1965 14.6642 10.5243 14.2709 11.1799 13.4842L15.8889 7.83333"
                                      stroke="white"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                    />
                                  </svg>
                                  <strong
                                    >Select your EHP product and flavour</strong
                                  >
                                </li>
                                <li>
                                  <svg
                                    width="22"
                                    height="23"
                                    viewBox="0 0 22 23"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="11"
                                      cy="11.5"
                                      r="11"
                                      fill="black"
                                    />
                                    <path
                                      d="M6.11114 11.5L8.2292 13.6181C8.9533 14.3422 9.31535 14.7042 9.75592 14.6842C10.1965 14.6642 10.5243 14.2709 11.1799 13.4842L15.8889 7.83333"
                                      stroke="white"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                    />
                                  </svg>
                                  <strong
                                    >Hit Subscribe & Save to select your
                                    frequency</strong
                                  >
                                </li>
                                <li>
                                  <svg
                                    width="22"
                                    height="23"
                                    viewBox="0 0 22 23"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="11"
                                      cy="11.5"
                                      r="11"
                                      fill="black"
                                    />
                                    <path
                                      d="M6.11114 11.5L8.2292 13.6181C8.9533 14.3422 9.31535 14.7042 9.75592 14.6842C10.1965 14.6642 10.5243 14.2709 11.1799 13.4842L15.8889 7.83333"
                                      stroke="white"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                    />
                                  </svg>
                                  <strong
                                    >We’ll deliver your goods, straight to your
                                    door</strong
                                  >
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                        <div class="skio-details--footer">
                          <a class="skio-manage-link" href="/a/account/login"
                            >Manage subscriptions</a
                          >
                        </div>
                      </div>
                    </details>
                  </label>
                </div>
              `
          )
        : ""}
      ${this.showAddToCartButton
        ? html`
            <button @click=${() => this.addToCart()} class="add-to-cart">
              Add to Cart
            </button>
          `
        : html``}
    </fieldset>
    <div class="skio-details-overlay">
    </div>`;
  }

  updated = (changed) => {
    if (changed.has("product") && this.product) {
      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        (selling_plan_group) => selling_plan_group.app_id === "SKIO"
      );

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort(function (a, b) {
          if (
            parseInt(a.name.replace(/\D/g, "")) <
            parseInt(b.name.replace(/\D/g, ""))
          )
            return -1;
          if (
            parseInt(a.name.replace(/\D/g, "")) >
            parseInt(b.name.replace(/\D/g, ""))
          )
            return 1;
          if (
            parseInt(a.name.replace(/\D/g, "")) ==
            parseInt(b.name.replace(/\D/g, ""))
          )
            return 0;
        });
      });
    }

    if (changed.has("selectedVariant") && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      let skioSellingPlanGroups = JSON.parse(
        JSON.stringify(this.skioSellingPlanGroups)
      );
      this.availableSellingPlanGroups = skioSellingPlanGroups.filter(
        (selling_plan_group) =>
          selling_plan_group.selling_plans.some((selling_plan) =>
            this.selectedVariant.selling_plan_allocations.some(
              (selling_plan_allocation) =>
                selling_plan_allocation.selling_plan_id === selling_plan.id
            )
          )
      );

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        //update each group with a default selected_selling_plan

        this.availableSellingPlanGroups.forEach((group) => {
          group.selling_plans = group.selling_plans.filter((x) =>
            this.selectedVariant.selling_plan_allocations.find(
              (y) => y.selling_plan_id == x.id
            )
          );
        });

        this.availableSellingPlanGroups.forEach((group) => {
          if (this.defaultFrequency) {
            let selling_plan = group.selling_plans.find((x) =>
              x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase())
            );
            if (selling_plan) group.selected_selling_plan = selling_plan;
            else group.selected_selling_plan = group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
        });

        if (
          this.startSubscription == true ||
          this.product.requires_selling_plan == true ||
          this.purchaseOption == "subscription"
        ) {
          //find a matching selling plan, or choose first available

          if (
            this.selectedSellingPlan == null ||
            this.selectedSellingPlan == undefined
          ) {
            this.selectSellingPlanGroup(this.availableSellingPlanGroups[0]);
          }

          let sellingPlanName = this.selectedSellingPlan?.name;

          let sellingPlanGroup = this.availableSellingPlanGroups.find((x) =>
            x.selling_plans.find((y) => y.name == sellingPlanName)
          );
          let sellingPlan = sellingPlanGroup?.selling_plans.find(
            (y) => y.name == sellingPlanName
          );
          if (sellingPlanName == sellingPlan.name) {
            this.selectedSellingPlanGroup = sellingPlanGroup;
            this.selectedSellingPlan = sellingPlan;
          } else {
            this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
            this.selectedSellingPlan =
              this.availableSellingPlanGroups[0].selling_plans[0];
          }
        } else {
          this.selectedSellingPlan, (this.selectedSellingPlanGroup = null);
        }
      } else {
        this.selectedSellingPlan, (this.selectedSellingPlanGroup = null);
      }

      //update the form that was passed, if any
      this.updateForm();
    }

    if (changed.has("selectedSellingPlan")) {
      //update price of price elements if applicable
      document
        .querySelectorAll(`[skio-price][skio-key="${this.key}"]`)
        .forEach((el) => {
          el.innerHTML = this.price(this.selectedSellingPlan);
        });

      //update display of external content elements
      document
        .querySelectorAll(`[skio-onetime-content][skio-key="${this.key}"]`)
        .forEach((el) => {
          this.selectedSellingPlan !== null
            ? (el.style.display = "none")
            : el.style.removeProperty("display");
        });

      document
        .querySelectorAll(`[skio-subscription-content][skio-key="${this.key}"]`)
        .forEach((el) => {
          this.selectedSellingPlan == null
            ? (el.style.display = "none")
            : el.style.removeProperty("display");
        });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          sellingPlan: this.selectedSellingPlan,
          key: this.key,
        },
      });

      this.dispatchEvent(event);

      //update the form that was passed, if any
      this.updateForm();
      this.updateExternalPrice();

      //update external selling_plan input value
      let sellingPlanInput = document.querySelector(
        'input[name="selling_plan"]'
      );
      this.selectedSellingPlan != null
        ? (sellingPlanInput.value = this.selectedSellingPlan.id)
        : (sellingPlanInput.value = "");
    }

    if (changed.has("formId")) {
      //update the form that was passed, if any
      this.updateForm();
    }
  };

  log = (...args) => {
    args.unshift("%c[skio]", "color: #8770f2;");
    console.log.apply(console, args);
  };

  error = (...args) => {
    args.unshift("%c [skio]", "color: #ff0000");
    console.error.apply(console, args);
  };

  detailsMouseover() {
    let details = this.renderRoot.querySelector(".skio-details");
    let summary = this.renderRoot.querySelector(".skio-details summary");
    let overlay = this.renderRoot.querySelector(".skio-details-overlay");
    if (!details.hasAttribute("open") && this.showDetailsHover == false) {
      this.showDetailsHover = true;
      overlay.style.pointerEvents = 'auto'
      overlay.style.display = "block";
      overlay.style.opacity = ".5"
      overlay.addEventListener('click', () => {
        this.detailsMouseleave()
      })
    }
  }

  detailsMouseleave() {
    let details = this.renderRoot.querySelector(".skio-details");
    let summary = this.renderRoot.querySelector(".skio-details summary");

    let overlay = this.renderRoot.querySelector(".skio-details-overlay");
    setTimeout(() => {
      if (details.hasAttribute("open") && this.showDetailsHover == true) {
        overlay.style.pointerEvents = "none";
        overlay.style.opacity = "0"
        overlay.removeEventListener("click", this.detailsMouseleave);
        summary.click();
        this.showDetailsHover = false;
      }
    },25)

  }

  updatePriceElement() {
    let priceEl = document.querySelector(
      `[data-skio-price="${this.product.id}"]`
    );
    if (priceEl) {
      //add formatted price here
      let high = 0;
      this.product.variants.forEach((variant) => {
        if (variant.price > high) high = variant.price;
      });
      let content = "";
      if (!this.selectedSellingPlan) {
        content = this.moneyFormatter
          .format(this.selectedVariant.price / 100)
          .replaceAll("A", "");
      } else {
        content = `<del>${this.moneyFormatter
          .format(high / 100)
          .replaceAll("A", "")}</del>${this.price(
          this.selectedSellingPlan
        ).replaceAll("A", "")}`;
      }
      priceEl.innerHTML = content;
    }
  }

  getMetadata(field) {
    let meta = this.meta;
    if (meta !== {}) {
      let fieldData = meta[field];
      if (fieldData) return fieldData;
      else return "";
    }
  }

  getVariantMetadata(variantId, field) {
    let meta = this.meta;
    if (meta !== {}) {
      let variantData = meta[variantId];
      if (variantData) {
        let fieldData = variantData[field];
        if (fieldData) return fieldData;
        else return "";
      }
    }
  }

  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      this.selectedSellingPlan
        ? (el.innerHTML = this.price(this.selectedSellingPlan))
        : (el.innerHTML = this.money(this.selectedVariant.price));
    });
    document
      .querySelectorAll(this.externalPriceSelectorWithCurrency)
      .forEach((el) => {
        this.selectedSellingPlan
          ? (el.innerHTML =
              this.price(this.selectedSellingPlan) + " " + this.currency)
          : (el.innerHTML =
              this.money(this.selectedVariant.price) + " " + this.currency);
      });
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    if (this.selectedSellingPlan)
      this.lastSellingPlanName = this.selectedSellingPlan.name;
    if (group) this.purchaseOption = "subscription";
    else this.purchaseOption = "onetime";

    //update the form that was passed, if any
    this.updateForm();
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(element, group) {
    let selling_plan = group.selling_plans.find((x) => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
      this.lastSellingPlanName = this.selectedSellingPlan.name;
    } else
      this.log(
        "Error: couldn't find selling plan with id " +
          element.value +
          " for variant " +
          this.selectedVariant.id +
          " from product " +
          this.product.id +
          " : " +
          this.product.handle
      );
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlanButton(plan, group) {
    let selling_plan = group.selling_plans.find((x) => x.id == plan.id);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
      this.lastSellingPlanName = this.selectedSellingPlan.name;
    } else
      this.log(
        "Error: couldn't find selling plan with id " +
          element.value +
          " for variant " +
          this.selectedVariant.id +
          " from product " +
          this.product.id +
          " : " +
          this.product.handle
      );
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0);
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan) return { percent: "0%", amount: 0 };

    if (selling_plan.name.includes("prepaid")) {
      let option = selling_plan.options[0]["value"];

      var numberPattern = /\d+/g;
      let result = parseInt(option.match(numberPattern).join(""));

      const price_adjustment = selling_plan.price_adjustments[0];
      const discount = { percent: "0%", amount: 0 };
      const price = this.selectedVariant.price * result;

      switch (price_adjustment.value_type) {
        case "percentage":
          discount.percent = `${price_adjustment.value}%`;
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          );
          break;
        case "fixed_amount":
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`;
          discount.amount = price - price_adjustment.value;
          break;
        case "price":
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) / price) * 100.0
          )}%`;
          discount.amount = price - price_adjustment.value;
          break;
      }

      return discount;
    } else {
      const price_adjustment = selling_plan.price_adjustments[0];
      const discount = { percent: "0%", amount: 0 };
      const price = this.selectedVariant.price;

      switch (price_adjustment.value_type) {
        case "percentage":
          discount.percent = `${price_adjustment.value}%`;
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          );
          break;
        case "fixed_amount":
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`;
          discount.amount = price_adjustment.value;
          break;
        case "price":
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) / price) * 100.0
          )}%`;
          discount.amount = price - price_adjustment.value;
          break;
      }

      return discount;
    }
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    if (selling_plan.name.includes("prepaid")) {
      let option = selling_plan.options[0]["value"];
      var numberPattern = /\d+/g;
      let result = parseInt(option.match(numberPattern).join(""));

      return formatted
        ? this.money(
            this.selectedVariant.price * result -
              this.discount(selling_plan).amount
          )
        : this.selectedVariant.price * result -
            this.discount(selling_plan).amount;
    } else {
      return formatted
        ? this.money(
            this.selectedVariant.price - this.discount(selling_plan).amount
          )
        : this.selectedVariant.price - this.discount(selling_plan).amount;
    }
  }

  // If a formId was passed, appends the necessary <input> elements to the form
  updateForm() {
    if (this.formId) {
      let form = document.querySelector(`#${this.formId}`);

      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) {
          selling_plan_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.selectedSellingPlan?.id
              : null;
          selling_plan_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          selling_plan_input = document.createElement("input");
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.selectedSellingPlan?.id
              : null;
          selling_plan_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(selling_plan_input);
        }

        let discountValue =
          this.selectedSellingPlan?.id !== undefined
            ? this.discount(this.selectedSellingPlan).percent
            : null;
        if (discountValue == "0%") discountValue = null;

        let discount_input = form.querySelector(
          '[name="properties[Discount]"]'
        );
        if (discount_input) {
          discount_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.discount(this.selectedSellingPlan).percent
              : null;
          discount_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
          if (discountValue == null) discount_input.disabled = true;
        } else {
          discount_input = document.createElement("input");
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.discount(this.selectedSellingPlan).percent
              : null;
          discount_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
          if (discountValue == null) discount_input.disabled = true;
          form.append(discount_input);
        }
      } else {
        console.log(
          `Skio error: form ID is ${this.formId}, but no form with that ID was found.`
        );
      }
    }
  }

  addVariantClickEventListeners() {
    let variantInputs = document.querySelectorAll(this.variantInputSelector);
    let skio = this;
    for (let el of variantInputs) {
      el.addEventListener("click", function (e) {
        // may need to replace with ID / e.target depending on client setup
        // may need to use different attribute depending on ^^
        let variantTitle = e.currentTarget.value;
        skio.selectedVariant = skio.product.variants.find(
          (variant) => variant.title == variantTitle
        );
      });
    }
  }

  // Optional functions keep if necessary

  /**
   *
   *
   */

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity = 1) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && {
          selling_plan: this.selectedSellingPlan?.id,
        }),
      },
    ];

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then((response) => {
        this.log("SKIO added item to cart: ", response);
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key,
          },
        });

        this.dispatchEvent(event);
      })
      .catch((error) => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error);
      });
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product;
        this.selectedVariant = product.variants[0];

        return product;
      });
  };
}

customElements.define("skio-plan-picker", SkioPlanPickerComponent);
